// extracted by mini-css-extract-plugin
export default {"editHeaderArea":"HeadTitleTable_editHeaderArea__jLqce","indexTitle":"HeadTitleTable_indexTitle__Hqvrf"};